module.exports = __webpack_public_path__ + "media/images/icons/info_white-4156441aa850aae3298ad28f53790435.png";